var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-5 pb-8",attrs:{"fluid":_vm.fluid}},[_c('custom-title',{staticClass:"pb-2 pb-md-8",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }